const calculators = document.querySelectorAll('.m-calculator')

const formatNumber = (number) => {
	if (number < 1000) {
		return number.toString();
	}

	if (number < 1000000) {
		const thousands = number / 1000;
		return thousands % 1 === 0 ?
			`${Math.floor(thousands)}K` :
			`${thousands.toFixed(1)}K`;
	}

	if (number < 1000000000) {
		const millions = number / 1000000;
		return millions % 1 === 0 ?
			`${Math.floor(millions)}Mio` :
			`${millions.toFixed(1)}Mio`;
	}

	const billions = number / 1000000;
	return `${Math.floor(billions)}Mio`;
};

calculators.forEach((calculator) => {
	const peopleInput = calculator.querySelector('#calculator_first');
	const monthsInput = calculator.querySelector('#calculator_second');
	const calculateBtn = calculator.querySelector('.calculate_btn');
	const resultElement = calculator.querySelector('.result-item span');
	const resultEditorElement = calculator?.querySelector('.editor-result');
	const calculatorWrapper = calculator.querySelector('.m-calculator__wrapper');
	const calculatorResult = calculator.querySelector('.m-calculator__result');
	const resetBtn = calculator.querySelector('.reset_btn');
	const followers = calculator.classList.contains('calculator-followers');

	const quantityControls = (inputElement) => {
		const container = inputElement.closest('.input-quantity');
		if (!container) return;

		const plusBtn = container.querySelector('.btn-qty__plus');
		const minusBtn = container.querySelector('.btn-qty__minus');

		const minValue = parseInt(inputElement.getAttribute('min')) || 1;
		const maxValue = parseInt(inputElement.getAttribute('max')) || 999999999999;

		if (!inputElement.value) {
			inputElement.value = minValue;
		}

		plusBtn.addEventListener('click', () => {
			let currentValue = parseInt(inputElement.value) || 0;
			if (currentValue < maxValue) {
				inputElement.value = currentValue + 1;
				inputElement.dispatchEvent(new Event('input'));
			}
		});

		minusBtn.addEventListener('click', () => {
			let currentValue = parseInt(inputElement.value) || 0;
			if (currentValue > minValue) {
				inputElement.value = currentValue - 1;
				inputElement.dispatchEvent(new Event('input'));
			}
		});

		const updateButtonStates = () => {
			const value = parseInt(inputElement.value) || 0;
			minusBtn.disabled = value <= minValue;
			plusBtn.disabled = value >= maxValue;
		};

		inputElement.addEventListener('input', updateButtonStates);
		updateButtonStates();
	};

	quantityControls(peopleInput);
	quantityControls(monthsInput);

	calculatorResult.style.display = 'none';
	calculatorResult.style.opacity = '0';

	const calculateResult = () => {
		const people = parseInt(peopleInput.value) || 0;
		const months = parseInt(monthsInput.value) || 0;

		const result = followers
			? (people * (months / 100) * 26)
			: (2.417 * people * months);
		const roundedResult = Math.floor(result);
		resultElement.textContent = formatNumber(roundedResult);
		resultEditorElement ? resultEditorElement.textContent = formatNumber(roundedResult) : false;
		calculatorWrapper.style.opacity = '0';

		setTimeout(() => {
			calculatorWrapper.style.display = 'none';
			calculatorResult.style.display = 'flex';

			calculatorResult.offsetHeight;
			calculatorResult.style.opacity = '1';
		}, 300);
	}

	const validateInputs = (e) => {
		const input = e.target;
		let value = parseInt(input.value) || 0;

		const minValue = parseInt(input.getAttribute('min')) || 1;
		const maxValue = input.id === 'calculator_second' ? (followers ? 100 : 12) : 999999999999;

		if (value < minValue) value = minValue;
		if (value > maxValue) value = maxValue;

		input.value = value;
	};

	const resetCalculator = () => {
		peopleInput.value = peopleInput.getAttribute('min') || 1;
		monthsInput.value = monthsInput.getAttribute('min') || 1;
		resultElement.textContent = '0';

		[peopleInput, monthsInput].forEach(input => {
			input.dispatchEvent(new Event('input'));
		});

		calculatorResult.style.opacity = '0';
		setTimeout(() => {
			calculatorResult.style.display = 'none';
			calculatorWrapper.style.display = 'flex';
			calculatorWrapper.offsetHeight;
			calculatorWrapper.style.opacity = '1';
		}, 300);
	};

	calculateBtn.addEventListener('click', calculateResult);
	peopleInput.addEventListener('input', validateInputs);
	monthsInput.addEventListener('input', validateInputs);
	resetBtn.addEventListener('click', resetCalculator);
})

